import { Hash, Sparkles, Target } from "lucide-react";
import React, { useState } from "react";
import { SectionHeader } from "../../components";
import { cn } from "../../utils/cn";
import EngagementPredictor from "./EngagementPredictor";
import HashtagRecommender from "./HashtagRecommender";

type LabTool = "prediction" | "hashtags";

/**
 * Aba "Laboratório de IA" — mescla o que antes eram as abas "Predições"
 * (EngagementPredictor.tsx) e "Hashtags" (HashtagRecommender.tsx). As duas
 * compartilham o mesmo padrão de interação (formulário → simulação sob
 * demanda), diferente do restante das abas, que são painéis de leitura
 * passiva — por isso viraram duas ferramentas dentro de um único
 * laboratório, em vez de duas abas separadas. A lógica interna de cada
 * ferramenta (fetch, estados, cálculos) não foi alterada — apenas passaram
 * a ser alternadas por um seletor local em vez de por abas de topo.
 */
const AILab: React.FC = () => {
  const [tool, setTool] = useState<LabTool>("prediction");

  return (
    <div className="space-y-2 animate-in fade-in slide-in-from-bottom-4 duration-700">
      {/* Mesmo tratamento visual do header de "Perfil Estratégico do ICP"
          (EmpathyMapDisplay.tsx): SectionHeader real dentro do seu próprio
          card, independente das ferramentas (EngagementPredictor/
          HashtagRecommender) que renderizam como irmãos abaixo. */}
      <div className="bg-white border border-purple-200 rounded-xl p-3 shadow-xs">
        <SectionHeader
          icon={<Sparkles className="h-5 w-5" />}
          title="Laboratório de IA"
          subtitle="Simulações sob demanda antes de publicar"
          hideBorder
          action={
            <div className="flex p-1 bg-gray-50/80 rounded-lg border border-purple-200 self-center">
              <button
                type="button"
                onClick={() => setTool("prediction")}
                className={cn(
                  "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[10px] font-black uppercase tracking-widest transition-all duration-300",
                  tool === "prediction"
                    ? "bg-purple-600 text-white shadow-xs"
                    : "text-gray-400 hover:text-purple-600 hover:bg-white",
                )}
              >
                <Target className="h-3.5 w-3.5" />
                Predição
              </button>
              <button
                type="button"
                onClick={() => setTool("hashtags")}
                className={cn(
                  "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[10px] font-black uppercase tracking-widest transition-all duration-300",
                  tool === "hashtags"
                    ? "bg-purple-600 text-white shadow-xs"
                    : "text-gray-400 hover:text-purple-600 hover:bg-white",
                )}
              >
                <Hash className="h-3.5 w-3.5" />
                Hashtags
              </button>
            </div>
          }
        />
      </div>

      {tool === "prediction" ? <EngagementPredictor /> : <HashtagRecommender />}
    </div>
  );
};

export default AILab;
